import { Injectable } from "@angular/core";
import { HttpClient, HttpResponse, HttpHeaders } from "@angular/common/http";
//Grab everything with import 'rxjs/Rx';
import { Observable, Observer, Subject, of } from "rxjs";
import { map, catchError, share, publishReplay } from "rxjs/operators";

import { environment } from "../../../../environments/environment";

import {
  PaymentService, LineItem, ProductSubType,
  PaymentSummary,
  PaymentDetails,
  PaymentUIConfiguration,
  CustType,
  GPOrgCode,
  OrderSource,
  OrderTypeCode,
  OrderDetails,
  OrgCode,
  CardType
} from "@acepteam/payment";
import * as globalsvc from "@acepteam/globalspack";
import { GroupPortalData } from "../../../shared/models";

declare var $: any;

@Injectable({
  providedIn: "root"
})
export class CheckoutService {
  clientPingResponseRxd$ = new Subject<boolean>();
  headers: HttpHeaders;
  clientsWithCallBackApis = [];
  isClientCallbackAvailable: boolean = false;
  constructor(
    private http: HttpClient,
    private globaldomops: globalsvc.GlobalDomOpsService,
    private globaldataops: globalsvc.GlobalDataOpsService,
    private ssosvc: globalsvc.AcepSSOService,
    private commonopssvc: globalsvc.CommonOperationsService,
    private paymentservice: PaymentService
  ) { }

  public CalculateOrder(memberAppData: GroupPortalData,UOM_Override: string = '') {
    let orderdetails: OrderDetails = new OrderDetails();

    orderdetails = {
      OrderId: "",
      CustomerType: CustType[CustType.Contact],
      TotalAmount: 0,
      TotalDiscount: null,
      AcepId: this.ssosvc.acepid,
      AccountNumber: "",
      ClientIPAddress: "",
      ClientID: this.ssosvc.acepid,
      Description: "",
      GPOrgCode: GPOrgCode.ACEP,
      OrderSource: OrderSource.Web,
      OrderTypeCode: OrderTypeCode[OrderTypeCode.MembershipIndividual],
      OrgCode: OrgCode.ACEP,
      PriceListName: "MEMBERSHIP",
      PromoCode: this.commonopssvc.getQueryString('campaign'), //campaign codes
      PaymentInformation: new PaymentDetails(),
      orderLineItems: this.CreateLineItemsToSendToCalculateOrder(memberAppData),
      TransactionId: "",
      AccountDetails: null,
      MemberIds: "",
      GroupOrder: "",
      PromoCodeValid: null,
      IsTrialMembership: null,
      PromoCodeMetadata: null,
      FutureMemberRate_Override: UOM_Override,
      CCEmail: "",

      TotalShipping: null,
      AllowShipping: null,
      ShippingAddress: null,
      ExisitngAddresses: null

    };
    
    if (orderdetails.PromoCode == null) {
      orderdetails.PromoCode = "";
    }

    return this.http
      .post(
        this.paymentservice.paymentWebServicePath + "CalculateOrder",
        JSON.stringify(orderdetails),
        { headers: this.paymentservice.paymentheaders }
      )
      .pipe(
        map((res: HttpResponse<any>) =>
          this.MapOrderDetailsFromCalculateOrderResponse(res)
        )
      );
  }

  MapOrderDetailsFromCalculateOrderResponse(res: any) {
    const orderdetails: OrderDetails = {
      OrderId: "",
      CustomerType: CustType[CustType.Contact],
      TotalAmount: res.totalAmount,
      TotalDiscount: res.totalDiscount,
      AcepId: this.ssosvc.acepid,
      AccountNumber: "",
      ClientIPAddress: "",
      ClientID: this.ssosvc.acepid,
      Description: "",
      GPOrgCode: GPOrgCode.MEMB,
      OrderSource: OrderSource.Web,
      OrderTypeCode: OrderTypeCode[OrderTypeCode.MembershipIndividual],
      OrgCode: OrgCode.ACEP,
      PriceListName: "MEMBERSHIP",
      PromoCode: res.promoCode,
      PaymentInformation: new PaymentDetails(),
      orderLineItems: this.MapLineItems(res.orderLineItems),
      TransactionId: "",
      AccountDetails: null,
      MemberIds: "",
      GroupOrder: "",
      PromoCodeValid: res.promoCodeValid,
      IsTrialMembership: res.promoCodeValid && res.isTrialMembership,
      PromoCodeMetadata: res.promoCodeMetadata,
      FutureMemberRate_Override: "",
      CCEmail: "",

      TotalShipping: res.totalShipping,
      AllowShipping: res.allowShipping,
      ShippingAddress: res.shippingAddress,
      ExisitngAddresses: res.exisitngAddresses

    };

    this.paymentservice.orderdetails = orderdetails;

    return res;
  }

  MapLineItems(oli: any): LineItem[] {
    let lineitems: LineItem[] = [];
    lineitems = oli.map(li => {
      return {
        ExtendedAmount: li.extendedAmount,
        ProductNumber: li.productNumber,
        ProductName: li.productName,
        Quantity: li.quantity,
        UnitPrice: parseFloat(li.unitPrice).toFixed(2), // li.unitPrice,
        UOM: li.uom,
        OverridePrice: li.overridePrice,
        IsPrimary: li.isPrimary,
        ProductSubType: li.productSubType,
        AccountId: li.accountId,
        Modifiable: li.modifiable,
        Selected: true //li.selected
      };
    });

    return lineitems;
  }


  CreateLineItemsToSendToCalculateOrder(memberAppData: GroupPortalData): LineItem[] {

    let lineItems: LineItem[] = [];
    if (!memberAppData.profile.IsInternational) {
      let chapters = memberAppData.chapterDetails.chapters.filter(c => c.selected);

      for (let index = 0; index < chapters.length; index++) {
        let li = new LineItem();
        li.ProductSubType = ProductSubType.ChapterDues;
        li.AccountId = chapters[index].id;
        li.ProductNumber = chapters[index].code;
        li.ProductName = chapters[index].name;
        li.IsPrimary = chapters[index].isPrimary;

        lineItems.push(li);
      }
    }



    let sections = memberAppData.sectionDetails.sections.filter(c => c.selected);

    for (let index = 0; index < sections.length; index++) {
      let li = new LineItem();
      li.ProductSubType = ProductSubType.SECT;
      li.AccountId = sections[index].id;
      li.ProductNumber = sections[index].code;
      li.ProductName = sections[index].name;

      lineItems.push(li);
    }


    return lineItems;

  }

  //   public SynchClientPayloadToACEPPayload(pJson: any) {
  //     let p = JSON.parse(pJson);
  //     let paymentuiconfig: PaymentUIConfiguration = new PaymentUIConfiguration();
  //     paymentuiconfig.PRMOCODELABEL = "Campaign Code"
  //     paymentuiconfig.CLIENT_GOBACKURL = p.backUrl;
  //     paymentuiconfig.CLIENT_RECEIPTURL = p.returnUrl;
  //     paymentuiconfig.CLIENT_CONFIRMURL = !!p.confirmUrl ? p.confirmUrl : "";

  //     paymentuiconfig.VENDOR = p.brand;
  //     paymentuiconfig.LOCKPROMOCODE = !!p.lockPromoCode
  //       ? p.lockPromoCode
  //       : paymentuiconfig.LOCKPROMOCODE;
  //     paymentuiconfig.LOCKAUTORENEWAL = !!p.lockAutoRenewal
  //       ? p.lockAutoRenewal
  //       : paymentuiconfig.LOCKAUTORENEWAL;
  //     paymentuiconfig.AUTORENEWAL_DESCRIPTION = !!p.autoRenewalDescription
  //       ? p.autoRenewalDescription
  //       : "";

  //     let orderdetails: OrderDetails = new OrderDetails();
  //     orderdetails.PaymentInformation = new PaymentDetails();
  //     orderdetails.AccountNumber = orderdetails.AcepId = p.customerNumber;
  //     if (this.ssosvc.acepid == p.customerNumber) {
  //       //dont pass account number if its a customer
  //       orderdetails.AccountNumber = "";
  //     } else {
  //       //Account
  //       orderdetails.CustomerType = CustType[CustType.Account];
  //     }

  //     orderdetails.OrderTypeCode = p.orderType;
  //     orderdetails.GPOrgCode = +GPOrgCode[p.gpOrganization];
  //     orderdetails.OrgCode = +OrgCode[p.organization];
  //     orderdetails.PriceListName = p.priceList;

  //     //override line item price only if price is not passed and price is not passed as 0
  //     p.lineItems.forEach(function(li) {
  //       li.OverridePrice =
  //         !!li.UnitPrice || parseFloat(li.UnitPrice) == 0 ? false : true;
  //     });

  //     orderdetails.orderLineItems = p.lineItems;
  //     orderdetails.PromoCode = !!p.promoCode ? p.promoCode : "";
  //     orderdetails.Description = !!p.description ? p.description : "";
  //     orderdetails.TransactionId = p.transactionId;
  //     orderdetails.ClientIPAddress = p.clientIpAddress;
  //     orderdetails.ClientID = paymentuiconfig.VENDOR + "-" + this.ssosvc.acepid;
  //     orderdetails.orderLineItems.forEach(function(li) {
  //       li.ExtendedAmount = "";
  //       li.ProductName = !!li.ProductName ? li.ProductName : "";
  //       li.Quantity = !!li.Quantity ? li.Quantity : "1";
  //       li.UnitPrice = !!li.UnitPrice ? li.UnitPrice : "0";
  //       li.UOM = !!li.UOM ? li.UOM : "EACH";
  //       li.OverridePrice = li.OverridePrice;
  //     });

  //     this.paymentservice.paymentuiconfig = paymentuiconfig;

  //    this.paymentservice.orderdetails = orderdetails;

  //     this.isClientCallbackAvailable =
  //       this.clientsWithCallBackApis.indexOf(
  //         paymentuiconfig.VENDOR.toUpperCase()
  //       ) > -1 || paymentuiconfig.CLIENT_CONFIRMURL != "";
  //     //this.UpdatePreferencesBasedOnOrderType(orderdetails.OrderTypeCode);
  //   }

  //   public AnalyzePaymentConfiguration(pJson: any) {
  //     if (pJson != null) {
  //       this.SynchClientPayloadToACEPPayload(pJson);

  //       this.paymentservice.orderdetails.AcepId = this.ssosvc.acepid;
  //       this.paymentservice.GetTotalPriceFromLineItems();
  //     }
  //   }

  public AddPaymentUIConfiguration() {
    // let paymentuiconfig: PaymentUIConfiguration = new PaymentUIConfiguration();
    // paymentuiconfig.PRMOCODELABEL = "Campaign Code";
    // paymentuiconfig.SHOWAMOUNT = true;
    // this.paymentservice.paymentuiconfig = paymentuiconfig;
    // this.paymentservice.orderdetails.AcepId = this.ssosvc.acepid;

    this.paymentservice.paymentuiconfig.VENDOR = `${this.globaldataops.ORG} Membership`
  }

  private initHeaders() {
    this.headers = new HttpHeaders();
    this.headers.set("Content-Type", "application/json");
    this.headers.set("Access-Control-Allow-Origin", "*");
    this.headers.set("Access-Control-Allow-Methods", "PUT, GET, POST");
    this.headers.set(
      "Access-Control-Allow-Headers",
      "Origin, X-Requested-With, Content-Type, Accept"
    );
  }
}
